export default __webpack_public_path__ + "static/media/OasisPotraitBG12.5c51357b.webp";